export default "__VITE_ASSET__BCVIiB1t__"